import { render } from "./ShowInterpellation.vue?vue&type=template&id=273b1c6c&scoped=true"
import script from "./ShowInterpellation.vue?vue&type=script&lang=js"
export * from "./ShowInterpellation.vue?vue&type=script&lang=js"

import "./ShowInterpellation.vue?vue&type=style&index=0&id=273b1c6c&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-273b1c6c"]])

export default __exports__